import styled from "@emotion/styled"
import Image from "next/image"
import colors from "theme/colors"
import {
  ButtonWithArrow,
  NewText,
  SmallDesktop,
  TitleWithLine,
  useIsDesktop,
  XSmall
} from "ui"
import { extractProperty } from "utils"

import { httpsImage } from "utils/utils"
import JoinForm from "./JoinForm"

const StyledJoiningWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 146px;
    padding-right: 146px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 220px;
    padding-right: 220px;
  }
`

const StyledGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-top: 28px;
  margin-bottom: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 355px;
    margin-top: 28px;
    margin-bottom: 100px;
    gap: 32px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    margin-top: 40px;
    grid-template-columns: 1fr 355px;
    gap: 45px;
  }
`

const StyledImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 380px;
  border-radius: 12px;
  overflow: hidden;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 450px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    height: 602px;
  }
`

const StyledTextWrapper = styled.div`
  position: absolute;
  margin: 12px;
  width: 220px;
  margin-left: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
     width: 285px;
    padding-top: 12px;
    margin-left: 52px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    width: 474px;
  }
`

const StyledButtonWrapper = styled.div`
  margin-top: 12px;

  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 24px;
  }
`

function JoiningPazomat({ data }: { data: any }) {
  const isDesktop = useIsDesktop()
  const boxBackgroundImage = extractProperty(data, "boxBackgroundImage")
  const backgroundImageMobile = extractProperty(data, "backgroundImageMobile")
  const boxTitle = extractProperty(data, "boxTitle")
  const textBox = extractProperty(data, "textBox")
  const boxLine = extractProperty(data, "boxLine")

  return (
    <StyledJoiningWrapper>
      <TitleWithLine
        titleFontSize={isDesktop ? 64 : 32}
        titleColor={colors.black}
        title="הצטרפות לפזומט"
      />
      <StyledGridWrapper>
        <StyledImageWrapper>
          <SmallDesktop>
            <Image
              src={httpsImage(boxBackgroundImage)}
              alt={""}
              fill
              quality={85}
              objectPosition="center right"
              objectFit="cover"
            />
          </SmallDesktop>
          <XSmall>
            <Image
              src={httpsImage(backgroundImageMobile)}
              alt={""}
              fill
              quality={85}
            // objectPosition="center right"
            // objectFit="cover"
            />
          </XSmall>
          <StyledTextWrapper>
            <NewText
              largeDesktopFontSize={28}
              largeDesktopLineHeight="35.84px"
              desktopFontSize={24}
              component="p"
              desktopLineHeight="33.6px"
              desktopFontWeight="500"
              color={colors.blue}
              mobileFontSize={16}
              mobileLineHeight={"24px"}
            >
              {boxTitle}
            </NewText>
            <NewText
              component="p"
              desktopFontSize={24}
              desktopLineHeight={"31.2px"}
              desktopFontWeight="500"
              color={colors.black}
              mobileFontSize={16}
              hugeDesktopFontSize={"36px"}
              hugeDesktopLineHeight="140%"
            >
              {textBox}
            </NewText>
            <StyledButtonWrapper>
              <ButtonWithArrow
                title={boxLine[0]?.name}
                desktopWidth={168}
                desktopHeight={48}
                largeDesktopFontSize={20}
                desktopFontSize={14}
                mobileWidth={126}
                mobileHeight={36}
                smallDesktopWidth={115}
                smallDesktopHeight={30}
                onClick={() => window.open(boxLine[0]?.url)}
              />
            </StyledButtonWrapper>
          </StyledTextWrapper>
        </StyledImageWrapper>

        <JoinForm />
      </StyledGridWrapper>
    </StyledJoiningWrapper>
  )
}

export default JoiningPazomat
